import type { IndicatorStatus } from '@openx/components-core/lib/StatusIndicator/StatusIndicator.tsx';
import { BidderCreativeStatus } from '@openx/types/gqlTypes.ts';

export const creativeStatusMap: Record<BidderCreativeStatus, IndicatorStatus> = {
  [BidderCreativeStatus.Active]: 'active',
  [BidderCreativeStatus.Paused]: 'paused',
};
